/**
 * delay(ms) – awaitable timeout helper.
 *
 * A tiny wrapper around setTimeout that returns a Promise, allowing you
 * to pause async/await code flow without pulling in larger libraries.
 *
 * await delay(250);  // pause for a quarter-second
 */
export const delay = (ms: number) =>
    new Promise<void>((resolve) => setTimeout(resolve, ms));